"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _uiSettings = require("composer-lib/redux/actions/uiSettings");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth,
    composition: state.composition,
    lock: state.lock,
    saveState: state.save
  };
};

var mapDispatchToProps = {
  showShareModal: _uiSettings.showShareModal
};
var ShareButtonContainer = (0, _createReactClass.default)({
  displayName: "ShareButtonContainer",
  propTypes: {
    auth: _propTypes.default.object.isRequired,
    className: _propTypes.default.string,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    showShareModal: _propTypes.default.func.isRequired
  },
  render: function render() {
    var _this$props = this.props,
        auth = _this$props.auth,
        className = _this$props.className,
        composition = _this$props.composition,
        lock = _this$props.lock,
        saveState = _this$props.saveState;
    var noEdit = (0, _lockHelpers.compositionLocked)(lock, auth, saveState) || composition.isReadOnly();

    if (noEdit) {
      return null;
    }

    var classes = (0, _classnames.default)('share-button', (0, _defineProperty2.default)({}, className, !!className));
    return _react.default.createElement(_UIButton.default, {
      use: "link",
      className: classes,
      onClick: this.props.showShareModal
    }, _react.default.createElement(_UIIcon.default, {
      className: "share-icon",
      name: "share",
      size: "small"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.header.share"
    }));
  }
});

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ShareButtonContainer);

exports.default = _default;
module.exports = exports.default;